// eslint-disable-next-line
import React from 'react';
import StudentRosterCard from './StudentRosterCard';
import './Attendance.scss';

interface StudentRosterCellProps {
  columnType: string;
  // eslint-disable-next-line
  studentStatusArray?: any[];
  emptyStateText?: string;
  index: number;
  maxRows: number; //The column with the most rows determines the maxRows
  cellClassName?: string;
}

export function StudentRosterCell({
  columnType = '',
  emptyStateText = '',
  studentStatusArray = [],
  index,
  maxRows,
  cellClassName = '',
}: StudentRosterCellProps) {
  //if array is empty and its first element in the column, show empty state text
  if (index === 0 && !studentStatusArray?.length) {
    return (
      <td
        rowSpan={maxRows}
        className={`student-roster-swimLane-container student-roster-swimLane-desc student-roster-cell--text-top ${cellClassName}`}
      >
        {emptyStateText}
      </td>
    );
  }

  const hasStudent = !!studentStatusArray?.[index];
  return studentStatusArray?.length ? (
    <td className={hasStudent ? `student-roster-swimLane-cell ${cellClassName}` : `p-0 ${cellClassName}`}>
      {hasStudent ? <StudentRosterCard student={studentStatusArray?.[index]} type={columnType} /> : null}
    </td>
  ) : null;
}
